<template>


<div id="calc-app-container" class="calc-app"> <!-- #calc-app-container -->
                      <div class="container">
                        <div class="row">
                          <div class="col-12">
                            <h1>Szybka pożyczka od ręki? 
                              <p class="highlight">U nas to możliwe!</p>
                            </h1>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <h4>Ile potrzebujesz?</h4>
                        </div>
                        <div class="col-7 text-end v-cloak">
                          <h2>{{loanAmount}} zł</h2>
                        </div>
                      </div>
                      <div class="row pb-2">
                        <div class="col-12">
                          <!--
                          <img src="assets/calc-piece--05.svg"/>
                          -->
                          <vue-slider 
                            dotSize="50"
                            v-model="loanAmount"
                            :tick-labels="sliderLabels"
                            :min="minAmount"
                            :max="maxAmount"
                            :interval="step"
                            ticks="always"
                            tick-size="4"
                            :tooltip="'none'"
                            @change="onSlide"
                            :process="false"
                            :height="3"
                          >
                          <template v-slot:dot>
                            <div class="vue-slider-dot-amount"></div>                            
                          </template>
                          </vue-slider>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-5">
                          <h4>Na jak długo?</h4>
                        </div>
                        <div class="col-7 text-end">
                          <h2>30 dni</h2>
                        </div>
                      </div>
                      <div class="row pb-2">
                        <div class="col-12">
                          <img class="no-events" src="static/calc-duration-slider-locked.svg"/>
                        </div>
                      </div>


                      <div class="row details">
                        <div class="col-12 bg-white pt-5 pb-3 px-3">
                            <a class="btn-get-a-loan"  href="javascript:void(0);" @click="goApplicate"><span>Weź pożyczkę</span></a>
                            <div class="d-flex">
                              <div class="flex-col me-4 min-width-150">
                                <p><span class="label">Odsetki:</span> {{interest}} zł</p>
                                <p><span class="label">Prowizja:</span> {{commission}} zł</p>
                                <p><span class="label">Całkowita kwota do zapłaty:</span>  {{total}} zł</p>   
                                
                              </div>
                              <div class="flex-col">
                                <p><span class="label">RRSO:</span> {{rrso}}%</p>
                                <p><span class="label">Obsługa:</span> {{service}} zł</p>
                                                       </div>
                            </div>
                        </div>
                      </div> 

                        <div class="row extra-info">
                          <div class="col-12 pt-1 pb-3 px-0">
                            <div class="d-flex justify-content-end">
                              <div class="flex-col me-4">
                                <a href="#"  data-bs-target="#CalcSliderModalInfo" data-bs-toggle="modal"><img class="me-2 icon" src="static/calc-info.svg"/>Formularz informacyjny</a>
                              </div>
                              <div class="flex-col">
                                <a href="#" data-bs-target="#CalcSliderModalExample" data-bs-toggle="modal"><img class="me-2 icon" src="static/calc-example.svg"/>Reprezentatywny przykład pożyczki</a>
                              </div>
                            </div>

                          </div>
                        </div>
                                              
                        <!-- Modal -->
                        <div class="modal info-modal  fade" id="CalcSliderModalInfo" tabindex="-1" aria-labelledby="CalcSliderModalInfo" aria-hidden="true"  ref="modal">
                          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Formularz informacyjny</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body" v-html="formText"></div>
                              <div class="modal-footer">
                                
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" >Zamknij</button>
                              </div>
                            </div>
                          </div>
                        </div> 
                        
                        <!-- Modal -->
                        <div class="modal info-modal  fade" id="CalcSliderModalExample" tabindex="-1" aria-labelledby="CalcSliderModalExample" aria-hidden="true"  ref="modal">
                          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Reprezentatywny przykład pożyczki</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body" v-html="exampleText">
                                
                              </div>
                              <div class="modal-footer">
                                
                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" >Zamknij</button>
                              </div>
                            </div>
                          </div>
                        </div>                        
                    </div>

                      
                  </div> <!-- #calc-app-container -->



</template>

<script>
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';
  import * as __modal_details from './modal_details.js';



    import __prm from './calc_params.json';


   

    export default {
        name: "CalcSlider",

        computed: {


          isLocal(){

            return !this.endpoint.length;
          },


          color(){


            return 'orange';
          }
            

        },


        components: {
      
          VueSlider
        },

        data(){
          return {
            delay: null,

              params: [],


                isLoggedIn: false,

                isVisible: true,

                minAmount: 1000,
                maxAmount: 4500,
                step: 100,

                uri: [],


                firstTreshold: 2000,


                labelValues: [500, 6000],

                sliderLabels: [],

                formText: '',
                exampleText: ''
            }
        },


        props: {


            endpoint: {
                type: String,
                default: 'http://localhost:8080'
            }



        },

      

        methods: {

            increment(){
              this.loanAmount += 100;
            },

            decrement(){
              this.loanAmount -= 100;
            },


         
            onSlide(v){

                if (!this.params.hasOwnProperty(String(v))) return;

                let dat = this.params[String(v)],
                    now = new Date(),
                    tom = new Date(Date.now() + 30 * 24*60*60*1000),
                    today = now.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1'),
                    tomorrow = tom.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

                // update store directly (flat 30d params, fixed tenor)
                this.loanAmount   = v;
                this.total        = dat[1];
                this.interest     = dat[2];
                this.service      = dat[3];
                this.commission   = dat[4];
                this.insurance    = dat[5];
                this.rrso         = dat[6];
                this.dailyInterest = parseInt(this.interest) / 30;
                this.nbpInterest  = ((parseFloat(v) * 0.23) / 365).toFixed(2);
                this.finishDate   = tomorrow;

                ['formText:info_form', 'exampleText:example'].map( name => {

                    this[ name.split(':')[0] ] = [
                        ['{m%POZYCZKA.KAPITAL}', this.loanAmount],
                        ['{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}', this.total],
                        ['{POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                        ['{m%POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                        ['{POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                        ['{m%POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                        ['{POZYCZKA.PRZYKLAD}', this.getConf('loan_sample')],
                        ['{POZYCZKA.PRZYKLAD_KWOTA}', this.getConf('sample_amount')],
                        ['{POZYCZKA.PRZYKLAD_PROWIZJA}', this.getConf('sample_fee')],
                        ['{POZYCZKA.PRZYKLAD_ODSETKI}', this.getConf('sample_interest')],
                        ['{POZYCZKA.PRZYKLAD_OBSLUGA}', this.getConf('sample_service')],
                        ['{POZYCZKA.PRZYKLAD_KOSZT}', this.getConf('sample_cost')],
                        ['{POZYCZKA.PRZYKLAD_RRSO}', this.getConf('sample_rrso')],
                        ['{POZYCZKA.PRZYKLAD_DATA}', this.getConf('sample_valid_from')],
                        ['{POZYCZKA.PRZYKLAD_CALKOWITA_KWOTA}', this.getConf('sample_total')],

                        ['{POZYCZKA.LICZBA_DNI}', 30],
                        ['{POZYCZKA.DATA_SPLATY}r.', this.finishDate+'r.'],
                        ['{POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                        ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                        ['{POZYCZKA.OPROCENTOWANIE}', this.interest],
                        ['{m%POZYCZKA.OPROCENTOWANIE}', this.interest],
                        ['{m%POZYCZKA.OPLATA_POCZATKOWA_PLUS_POZYCZKA.OPLATA_ZA_OBSLUGE}', this.commission+this.service],

                        ['{POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)],
                        ['{m%POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)],

                        ['{POZYCZKA.KOSZT}', this.service + this.interest + this.commission],

                        ['{POZYCZKA.LICZBA_RAT}', 1],
                        ['{POZYCZKA.OKRES}', 1],
                        ['{m%POZYCZKA.KWOTA_RATY}', (this.total/ 1).toFixed(2)],
                        ['{POZYCZKA.RRSO}', this.rrso+' '],
                        ['{POZYCZKA.DATA_UMOWY}', today],
                        ['{POZYCZKA.DATA_WNIOSKU}', today],
                        ['{POZYCZKA.DATA_SPLATY}', this.finishDate],
                        ['{POZYCZKA.DATA_WNIOSKU_PLUS_1D}', tomorrow],
                        ['{m%POZYCZKA.OPLATA_ZA_OBSLUGE}', this.service],

                        ['{POZYCZKA.ODSETKI_DZIENNE_NBP}', this.nbpInterest]
                    ]
                    .reduce((acc, itm) => acc.replaceAll(new RegExp(itm[0], 'g'), itm[1]),
                        __modal_details[ name.split(':')[1] ]);
                });
            },


            goApplicate(){

                if (this.isLocal) {

                  this.echo('calc_edit_done');
                }
                else {
                  window.location = this.endpoint + '?amount=' + this.loanAmount + (this.uri.length > 1 ? '&' + this.uri[1] : '');
                }
            },


            goLogin(){

              if (this.isLocal && this.hasOwnProperty('echo')) {
                this.echo('login_dialog');
              }
              else {
                window.location = this.endpoint + '?login';
              }
            }

         
        },     





        created() {


            let uri = window.location.href.split('?');

            this.uri = uri;


            this.isLoggedIn = !!localStorage.getItem('user');


            if (this.isLocal) {


              this.listen('logged_in', () => {
                this.isLoggedIn = true;
              });

              this.listen('logged_out', () => {
                this.isLoggedIn = false;
              });
            }
        



            if (typeof __prm == 'object') {
                let t, i, o;
                for (t in __prm) {
                    if (__prm.hasOwnProperty(t)) {
                        for (i in __prm[t]) {
                            if (__prm[t].hasOwnProperty(i)) {
                                o = String(i).split('_');
                                this.params[ '' + String(o[0].replace('-', '.') * 100) ] = __prm[t][i];
                            }
                        }
                    }
                }


                // initial
                this.onSlide(this.loanAmount);

                this.sliderLabels = this.labelValues.reduce((accu, itm) => {

                  if (!accu){
                    return [itm];
                  }

                  return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
                }, 0);


            }


    

          
        },

        mounted(){









        }
    }
</script>


<style >
  .vue-slider-rail {
     background-color: #003b49 !important;
  }
</style>


// WEBPACK FOOTER //
// src/CalcSlider.vue